import * as React from "react";
import { AnalyticsTrigger } from "../helpers/analytics/analytics-trigger/analytics-trigger.mjs";
import { CookieConsentContext } from "../helpers/cookie-consent-provider/cookie-consent-provider.mjs";
import { Icon } from "../icon/icon/icon.mjs";
import { Image } from "../image/image.mjs";
import { useLabels } from "../helpers/label-provider/use-labels.mjs";
import { PropsChecker } from "../helpers/props-checker/props-checker.mjs";
const Video = (props) => {
  const labels = useLabels();
  return /* @__PURE__ */ React.createElement(PropsChecker, { componentProps: props, componentName: "Video", defaultValueName: "defaultPlaying", valueName: "playing", onChangeNames: "onPlay" }, /* @__PURE__ */ React.createElement(
    AnalyticsTrigger,
    {
      trigger: {
        callback: "onPlay",
        id: "Video - ".concat(props.title),
        elementType: "video",
        elementId: props.title,
        interactionType: "play"
      }
    },
    /* @__PURE__ */ React.createElement(VideoInner, { ...props, labels })
  ));
};
const _VideoInner = class _VideoInner extends React.Component {
  constructor(props) {
    super(props);
    this.iframe = React.createRef();
    this.handleClick = (event) => {
      event.preventDefault();
      this.play();
      setTimeout(() => {
        var _a;
        (_a = this.iframe.current) == null ? void 0 : _a.focus();
      });
    };
    this.play = () => {
      if (typeof this.props.playing === "undefined") {
        this.setState({
          playing: true
        });
      }
      if (this.props.onPlay) {
        this.props.onPlay();
      }
    };
    this.getUrl = (props2) => {
      let url = props2.url + "?autoplay=1";
      if (this.props.defaultPlaying) {
        url += "&muted=1";
      }
      return url;
    };
    this.state = {
      playing: props.defaultPlaying || false,
      hideOverview: props.hideOverview || false,
      isMounted: false
    };
  }
  componentDidMount() {
    this.hideOverview();
    this.setState({
      isMounted: true
    });
  }
  componentDidUpdate() {
    this.hideOverview();
  }
  get playing() {
    const { needsConsent } = this.props;
    if (!this.context.hasConsent(needsConsent)) {
      return false;
    }
    return this.props.onPlay && typeof this.props.playing !== "undefined" ? this.props.playing : this.state.playing;
  }
  hideOverview() {
    if (!this.state.hideOverview && this.playing) {
      this.setState({
        hideOverview: true
      });
    }
  }
  BEM(modifier) {
    const { needsConsent, position, className } = this.props;
    const classArray = ["video"];
    if (this.state.hideOverview) {
      classArray.push("hide-overview");
    }
    if (position) {
      classArray.push("video--" + position);
    }
    if (!this.context.hasConsent(needsConsent)) {
      classArray.push("video--needs-consent");
    }
    if (className) {
      classArray.push(className);
    }
    if (modifier) {
      classArray.push(modifier);
    }
    return classArray.join(" ");
  }
  renderIframe(props) {
    const {
      className,
      defaultPlaying,
      elementRef,
      hideOverview,
      hideWithoutConsent,
      needsConsent,
      onLoad,
      onPlay,
      placeholderText,
      playing,
      position,
      poster,
      title,
      url,
      ...rest
    } = props;
    const iframe = /* @__PURE__ */ React.createElement(
      "iframe",
      {
        ref: this.iframe,
        tabIndex: this.playing ? 0 : -1,
        title: props.title,
        className: "video__iframe lazyload",
        "data-src": this.playing ? this.getUrl(props) : void 0,
        width: "640",
        height: "360",
        allowFullScreen: true,
        onLoad: props.onLoad
      }
    );
    return this.renderVideoWrapper(this.BEM(), iframe, rest, props.url);
  }
  renderPosterImage() {
    const { poster } = this.props;
    const { alt, role, ...rest } = poster;
    return /* @__PURE__ */ React.createElement(Image, { className: "video__image", ...rest, role: "presentation" });
  }
  renderVideoWrapper(className, children, implementationSpecificProps, linkHref) {
    const { needsConsent, title, placeholderText } = this.props;
    const showOnlyImage = this.props.hideWithoutConsent === "showPoster" && !this.context.hasConsent(needsConsent);
    const { labels, ...rest } = implementationSpecificProps;
    const videoContent = /* @__PURE__ */ React.createElement(React.Fragment, null, this.renderPosterImage(), /* @__PURE__ */ React.createElement("span", { className: "video__content" }, /* @__PURE__ */ React.createElement("span", { className: "video__icon-wrapper" }, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#play", className: "video__icon" })), /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, "".concat(placeholderText != null ? placeholderText : labels == null ? void 0 : labels.get("playVideo"), " - ")), /* @__PURE__ */ React.createElement("span", { className: "video__title" }, title)));
    const buttonOrAnchor = this.context.hasConsent(needsConsent) ? /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        tabIndex: this.playing ? -1 : void 0,
        className: "video__btn",
        onClick: this.handleClick,
        ref: this.props.elementRef
      },
      videoContent
    ) : /* @__PURE__ */ React.createElement("a", { href: linkHref, className: "video__btn", target: "_blank", rel: "noopener noreferrer", ref: this.props.elementRef }, videoContent);
    return /* @__PURE__ */ React.createElement("figure", { className, "data-theme": this.props.theme, ...rest }, /* @__PURE__ */ React.createElement("div", { className: "video__inner" }, showOnlyImage ? this.renderPosterImage() : /* @__PURE__ */ React.createElement(React.Fragment, null, buttonOrAnchor, /* @__PURE__ */ React.createElement("div", { className: "video__holder" }, children))));
  }
  render() {
    const { needsConsent, hideWithoutConsent } = this.props;
    if (!this.context.hasConsent(needsConsent) && typeof hideWithoutConsent === "boolean" && hideWithoutConsent) {
      return null;
    }
    return this.renderIframe(this.props);
  }
};
_VideoInner.defaultProps = {
  needsConsent: ["statistics", "marketing"]
};
_VideoInner.contextType = CookieConsentContext;
let VideoInner = _VideoInner;
export {
  Video
};
